import Hero from '../../components/Hero/Hero';
import About from '../../components/About/About';
import Services from '../../components/Services/Services';
import MostPopular from '../../components/MostPopular/MostPopular';
import HomeHelmetComponent from './HomeHelmetComponent';
import Testimonials from 'components/Testimonial/Testimonial';

const Home = () => {
    return (
        <>
            <HomeHelmetComponent />
            <Hero />
            <Services />
            <MostPopular />
            <About />
            <Testimonials />
            
        </>
    );
};

export default Home;
